/* Limited Drop: Live-Countdown, Sticky-Leiste (Bundle-Vorlagen), Sold Count zum Fly-Bundles-Widget */
(function () {
  'use strict';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var html = document.documentElement;

  /* --- Countdown ---
     Elements with data-drop-end count down to the end of the drop, elements with data-drop-start to its start.
     Ticks every second: the seconds tile (start countdown) and the draining line on the minutes tile need it. */
  var countdowns = Array.prototype.slice.call(document.querySelectorAll('[data-drop-end], [data-drop-start]'));
  var ended = false;
  var reloadScheduled = false;

  // Scoreboard flip for the tiles of the drop module: the old number tips away over the top edge, the new one
  // drops in from below. Two short WAAPI steps (110 ms out, 190 ms in), so a tile is settled well before the
  // next second. No flip on the first paint, in background tabs or with reduced motion.
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setNumber(node, value, delay) {
    if (node.textContent === value) return;
    var canFlip = node.classList.contains('limited-drop-module__num')
      && node.hasAttribute('data-drop-ready')
      && typeof node.animate === 'function'
      && !reduceMotion
      && !document.hidden;
    node.setAttribute('data-drop-ready', '');
    if (!canFlip) {
      node.textContent = value;
      return;
    }
    if (node.dropFlip) node.dropFlip.cancel();
    var out = node.animate(
      [
        { transform: 'rotateX(0deg)', opacity: 1 },
        { transform: 'rotateX(-90deg)', opacity: 0.4 }
      ],
      { duration: 110, delay: delay || 0, easing: 'linear', fill: 'forwards' }
    );
    node.dropFlip = out;
    out.onfinish = function () {
      node.textContent = value;
      out.cancel();
      node.dropFlip = node.animate(
        [
          { transform: 'rotateX(90deg)', opacity: 0.4 },
          { transform: 'rotateX(0deg)', opacity: 1 }
        ],
        { duration: 190, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
      );
    };
  }

  function render(el) {
    var isStart = el.hasAttribute('data-drop-start');
    var target = Number(el.getAttribute(isStart ? 'data-drop-start' : 'data-drop-end')) * 1000;
    var diff = target - Date.now();
    // Tiles that change in the same tick flip one after the other, starting with the fastest unit.
    var changed = 0;
    var set = function (selector, value) {
      var node = el.querySelector(selector);
      if (!node || node.textContent === value) return;
      setNumber(node, value, changed * 50);
      changed += 1;
    };
    if (diff <= 0) {
      set('[data-drop-d]', '0');
      set('[data-drop-h]', '00');
      set('[data-drop-m]', '00');
      set('[data-drop-s]', '00');
      el.style.setProperty('--drop-minute-left', '0');
      if (el.parentNode && el.parentNode.style) el.parentNode.style.setProperty('--drop-minute-left', '0');
      return false;
    }
    set('[data-drop-s]', pad(Math.floor((diff % 60000) / 1000)));
    set('[data-drop-m]', pad(Math.floor((diff % 3600000) / 60000)));
    set('[data-drop-h]', pad(Math.floor((diff % 86400000) / 3600000)));
    set('[data-drop-d]', String(Math.floor(diff / 86400000)));

    // Share of the current minute that is still left. When a new minute starts the value jumps back up:
    // skip the transition for that tick, otherwise the line would grow back visibly.
    var minuteLeft = (diff % 60000) / 60000;
    var previous = Number(el.getAttribute('data-drop-minute-left') || 0);
    el.classList.toggle('is-resetting', minuteLeft > previous);
    el.setAttribute('data-drop-minute-left', minuteLeft);
    // Set on the parent as well: the seconds bar is a sibling of the countdown, not a child.
    el.style.setProperty('--drop-minute-left', minuteLeft.toFixed(4));
    if (el.parentNode && el.parentNode.style) el.parentNode.style.setProperty('--drop-minute-left', minuteLeft.toFixed(4));
    return true;
  }

  // The server decides about buy buttons and states, so a finished countdown reloads the page.
  // A cached page can still show the old state: retry a few times with growing delays, then stop.
  function reloadForNewState() {
    if (reloadScheduled) return;
    reloadScheduled = true;
    var key = 'limited-drop-reload:' + window.location.pathname;
    var attempts = 0;
    try { attempts = Number(window.sessionStorage.getItem(key) || 0); } catch (e) { attempts = 3; }
    if (attempts >= 3) return;
    try { window.sessionStorage.setItem(key, String(attempts + 1)); } catch (e) { return; }
    setTimeout(function () { window.location.reload(); }, 1500 + attempts * 8000);
  }

  function tick() {
    var running = false;
    var endRunning = false;
    countdowns.forEach(function (el) {
      if (render(el)) {
        running = true;
        if (el.hasAttribute('data-drop-end')) endRunning = true;
      }
    });
    if (running) {
      try { window.sessionStorage.removeItem('limited-drop-reload:' + window.location.pathname); } catch (e) {}
    }
    var hasEnd = countdowns.some(function (el) { return el.hasAttribute('data-drop-end'); });
    if (hasEnd && !endRunning && !ended) {
      ended = true;
      html.classList.add('limited-drop-ended');
    }
    if (!running && countdowns.length) reloadForNewState();
  }
  if (countdowns.length) { tick(); setInterval(tick, 1000); }

  /* --- Sticky-Leiste (Bundle-Vorlagen) --- */
  var sticky = document.querySelector('[data-limited-drop-sticky]');
  var widgetWrapper = function () {
    var offer = document.querySelector('.gfbFrequentBoughtWidgetOfferContainer');
    return offer ? (offer.closest('.gfbPageWrapper') || offer) : null;
  };
  var widgetCta = function () { return document.querySelector('.gfbFrequentBoughtAddToCartButton'); };

  if (sticky) {
    var header = document.querySelector('[data-limited-drop-bar]');
    var headerOut = !header;
    var ctaIn = false;
    var update = function () {
      var visible = headerOut && !ctaIn && !ended;
      sticky.classList.toggle('is-visible', visible);
      html.classList.toggle('limited-drop-sticky-active', visible);
    };

    if (header && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        headerOut = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        update();
      }, { threshold: 0 }).observe(header);
    } else {
      headerOut = true;
    }

    var watchCta = function () {
      var cta = widgetCta();
      if (!cta || !('IntersectionObserver' in window)) return !!cta;
      new IntersectionObserver(function (entries) {
        ctaIn = entries[0].isIntersecting;
        update();
      }, { threshold: 0.25 }).observe(cta);
      return true;
    };
    if (!watchCta() && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (watchCta()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }

    var button = sticky.querySelector('[data-limited-drop-scroll]');
    if (button) {
      button.addEventListener('click', function () {
        var target = widgetWrapper()
          || document.querySelector('[data-limited-drop-sold-count-move]')
          || document.querySelector('[id*="fly_bundles"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    update();
  }

  /* --- Fashion-Overlay: einmaliger Swoosh beim Laden, Groessen als CSS-Variablen.
         Kein Puls, kein Fade beim Swipen (Michel 25.09.: jede Animation auf dem geblendeten Badge
         zeigte auf iOS einen Versatz) --- */
  var posters = Array.prototype.slice.call(document.querySelectorAll('[data-limited-drop-poster]'));
  if (posters.length) {
    posters.forEach(function (el) {
      el.classList.add('is-entering');
      setTimeout(function () {
        // Desktop: Endlage der Scanner-Fahrt halten (Balken bleibt unten), sonst wuerde er zurueckspringen
        var badge = el.querySelector('.limited-drop-poster__badge');
        if (badge && window.matchMedia('(min-width: 1024px)').matches) badge.classList.add('is-scanned');
        el.classList.remove('is-entering');
      }, 3400); // 0,6 s Delay + 2,6 s Fahrt + Puffer
    });

    // The brand mark blends against the product image ("darken"). While the theme's image reveal runs
    // (scale and fade, about 1.3 s) the image sits on its own compositing layer and iOS Safari skips the
    // blending, so the lines would lie on top of the garment and jump back afterwards.
    // Show the mark only once the image is fully revealed and no longer animating.
    posters.forEach(function (el) {
      if (!el.querySelector('.limited-drop-poster__mark')) return;
      var item = el.closest('.product-media__item') || el.parentNode;
      var startedAt = Date.now();
      var settle = function () { el.classList.add('is-settled'); };
      var check = function () {
        var img = item ? item.querySelector('img') : null;
        var revealed = img && img.complete && getComputedStyle(img).opacity === '1';
        // Finished animations with fill-mode forwards may still be listed, so only running ones count.
        var animating = img && img.getAnimations
          ? img.getAnimations().some(function (a) { return a.playState === 'running'; })
          : false;
        if ((revealed && !animating) || Date.now() - startedAt > 6000) {
          settle();
        } else {
          setTimeout(check, 150);
        }
      };
      check();
    });

    var measure = function (el) {
      var r = el.getBoundingClientRect();
      if (r.width) {
        el.style.setProperty('--poster-w', r.width + 'px');
        el.style.setProperty('--poster-h', r.height + 'px');
        el.classList.add('is-ready'); // Desktop-Balken erst nach der Messung sichtbar
      }
    };
    posters.forEach(measure);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) { entries.forEach(function (e) { measure(e.target); }); });
      posters.forEach(function (el) { ro.observe(el); });
    } else {
      window.addEventListener('resize', function () { posters.forEach(measure); });
    }
  }

  /* --- Desktop: Masse fuer Badge-Scan und Galerie-Pin ---
     --hero-h: Hoehe des Hauptbilds (Scan-Ende), --limited-drop-badge-top: Viewport-Position der Hauptbild-Unterkante
     (Sticky-Versatz des Balkens), Galerie pinnt, sobald ihre Unterkante (inkl. Ablageflaeche) den Balken erreicht. */
  var media = document.querySelector('.product--limited-drop .product__media');
  if (media) {
    var mq = window.matchMedia('(min-width: 1024px)');
    var setMediaTop = function () {
      if (!mq.matches) {
        media.style.removeProperty('--limited-drop-media-top');
        return;
      }
      var hero = media.querySelector('.product-media__item');
      var poster = media.querySelector('.limited-drop-poster--badge');
      // Der Header bleibt beim Scrollen stehen: seine Hoehe auch oben auf der Seite nehmen (--header-height ist dort 0).
      var header = document.querySelector('header-wrapper');
      var hh = header && header.dataset.enableStickyHeader === 'true'
        ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-internal')) || 0
        : 0;
      var mediaRect = media.getBoundingClientRect();
      var mediaTopPage = mediaRect.top + window.scrollY;
      var barH = poster ? poster.getBoundingClientRect().width / 12 : 0; // one row of the poster grid, see --bar-h
      var heroH = hero ? hero.getBoundingClientRect().height : 0;
      var badgeTop = Math.min(mediaTopPage + heroH - barH, window.innerHeight - barH - 24);
      badgeTop = Math.max(badgeTop, hh + 24);
      if (poster) {
        // No rounding: the bar has to meet the grid line of the last poster row, which sits on a fractional pixel.
        poster.style.setProperty('--hero-h', heroH.toFixed(2) + 'px');
        poster.style.setProperty('--limited-drop-badge-top', badgeTop.toFixed(2) + 'px');
      }
      // Galerie pinnt, wenn ihre Unterkante auf badgeTop + barH steht (Balken liegt dann unter der letzten Reihe)
      var top = Math.min(hh + 24, badgeTop + barH - media.offsetHeight);
      media.style.setProperty('--limited-drop-media-top', Math.round(top) + 'px');
    };
    setMediaTop();
    window.addEventListener('resize', setMediaTop);
    window.addEventListener('load', setMediaTop);
    if ('ResizeObserver' in window) new ResizeObserver(setMediaTop).observe(media);
  }

  /* --- Sold Count auf Bundle-Vorlagen direkt über das Fly-Bundles-Widget ziehen --- */
  var sold = document.querySelector('[data-limited-drop-sold-count-move]');
  if (sold) {
    var move = function () {
      var wrapper = widgetWrapper();
      if (!wrapper || !wrapper.parentNode) return false;
      wrapper.parentNode.insertBefore(sold, wrapper);
      sold.classList.add('limited-drop-sold-count-wrapper--moved');
      return true;
    };
    if (!move() && 'MutationObserver' in window) {
      var mo2 = new MutationObserver(function () { if (move()) mo2.disconnect(); });
      mo2.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo2.disconnect(); }, 20000);
    }
  }
})();
